<template lang="pug">
.hx-main.hdpouoemlOdds3
  //- small.text-white {{ details['child2'] }}
  //- small.text-white TEST
  .hx-table.hx-match.hx-compact.live(:class="{ 'alternate' : source.matchIndex % 2 == 0 }")
    .hx-cell.w-62
      .hx-row.h-100.hx-rows
        timePanel(:source="source")
    .hx-cell.flex-fill
      .hx-row.h-100.hx-rows
        xTeam(:source="source" isDraw=false)
        xFavorite(:source="source")
    .hx-cell.w-328
      .hx-row.hx-rows(v-for="(dn, i) in details['kns']")
        mlItem(:details="details" :oddsType="oddsType" :i="i" betType="ml")
        hdpItem(:details="details" :oddsType="oddsType" :i="i" betType="hdp")
        ouItem(:details="details" :oddsType="oddsType" :i="i" betType="ou")
        oeItem1(:details="details" :oddsType="oddsType" :i="i" betType="oe")
    .hx-cell.w-40
      .hx-row.h-100.hx-rows
        .hx-col.hx-cols.w-100.d-flex.align-items-center.justify-content-center
          template(v-if="details['more'] > 0")
            .hx-more(
              :id="'morehead_' + id"
              data-toggle='collapse'
              :aria-expanded="false"
              :data-target="'#morebet_' + id"
              :aria-controls="'morebet_' + id"
              @click="handleMore(matchId, $event.target)"
              )
              i.far.fa-chevron-up
              span &nbsp;{{ details['more'] }}

  template(v-if="details['more'] > 0")
    .hx-table.hx-match.hx-morebet.collapse.show.live(
      :id="'morebet_' + id"
      :aria-labelledby="'morehead_' + id"
      :class="{ 'alternate' : source.matchIndex % 2 == 0 }"
      )
      morePanel(
        ref="morePanel"
        :uid="id"
        :details="moreItems"
        :child1Ids="details['child1']"
        :child2Ids="details['child2']"
        :matchId="matchId"
        :leagueId="leagueId"
        :marketType="marketType"
        :sportsType="sportsType"
        :betType="betType"
        :layoutIndex="layoutIndex"
      )
</template>

<script>
import mixinHDPOUOdds from "@/library/mixinHDPOUOdds";

export default {
  components: {
    timePanel: () => import("@/components/desktop/main/xtable/timePanel"),
    morePanel: () => import("@/components/desktop/main/xheader/morePanel"),
    xTeam: () => import("@/components/desktop/main/xtable/xitem/xTeam"),
    xFavorite: () => import("@/components/desktop/main/xtable/xitem/xFavorite"),
    mlItem: () => import("@/components/desktop/main/xtable/xitem/mlItem"),
    hdpItem: () => import("@/components/desktop/main/xtable/xitem/hdpItem"),
    ouItem: () => import("@/components/desktop/main/xtable/xitem/ouItem"),
    oeItem1: () => import("@/components/desktop/main/xtable/xitem/oeItem1"),
  },
  mixins: [mixinHDPOUOdds],
};
</script>
